export const appVersion = { version: '4378411' };
